/** @jsxImportSource @emotion/react */
import { useId, useState } from "react";
import ScheduledReportsTable from "tables/ScheduledReportsTable";
import { TableIdProvider } from "context/tableId";
import Alert from "components/common/Alert";
import useGetScheduledReportsQuery from "hookQueries/useGetScheduledReports";
import ScheduledReportsFormModal from "./ScheduledReportsFormModal";
import Layout from "./Layout";

export default function ScheduledReports() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const tableId = useId();

  const { data: reports, isLoading } = useGetScheduledReportsQuery();

  const handleCreateReport = () => {
    setSelectedReport(null);
    setIsModalOpen(true);
  };

  const handleEditReport = (report) => {
    setSelectedReport(report);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedReport(null);
  };
  const title = "Scheduled Reports";
  const hasData = !isLoading && reports?.length;

  return (
    <Layout handleCreateReport={handleCreateReport}>
      <div>
        {hasData ? (
          <TableIdProvider value={{ tableId }}>
            <ScheduledReportsTable
              reports={reports}
              isLoading={isLoading}
              onEdit={handleEditReport}
            />
          </TableIdProvider>
        ) : (
          <div className="flex-a-c-j-c">
            <Alert title={title} type="info" message="No data" />
          </div>
        )}

        {isModalOpen && (
          <ScheduledReportsFormModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            report={selectedReport}
          />
        )}
      </div>
    </Layout>
  );
}
